import { X } from "react-bootstrap-icons"

const Close = ({onClick}) => {
    return <div className="text-end">
        <X className="h-100" size={32} onClick={onClick}/>
    </div>
}

export default Close